// ---- SASS
import '@/sass/reset.sass'
import '@/sass/ui.sass'
import '@/sass/grid.sass'
import '@/sass/layout.sass'
import '@/assets/css/animate.css'
import 'font-awesome/css/font-awesome.css'


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import dayjs from '@/js/dayjs.min.js'

// 載入 Library
import APIs from './libs/APIs'
import Common from './libs/Common'
import LiffSdk from './libs/Liff'

import Vant from 'vant';
import 'vant/lib/index.css';
import { Calendar } from "vant";

// 載入店家資料
import StationData from './assets/json/stations.json'

// install Swiper modules
Vue.config.productionTip = false
Vue.use(VueLocalStorage)
Vue.prototype.dayjs = dayjs
Vue.use(Vant);
Vue.use(Calendar);


new Vue({
  router,
  render: h => h(App),
  data: {
    webviewUri: '',
    run_code: '',
    apis: false,
    common: false,
    liff: false,
    liffId: process.env.VUE_APP_LIFF_ID,
    runType: process.env.VUE_APP_NODE,
    actionType: '',
    platform: false,
    user: { userId: false },
    member: {
      user_lineId: "",
      user_name: "",
      user_picture: "",
      user_phone: "",
      name: ""
    },
    phone: '',
    // 站點清單
    stations: [],
    types: [
      { id: 1, type: 1, code: '旅生活交通', title: '<p>旅生活交通租賃</p>', description: '小客車、機車、自行車、電輔車、滑板車、露營車、兒童玩具車...等', img: require("@/assets/images/main-type-1.svg") },
      { id: 2, type: 2, code: '旅生活工具', title: '<p>旅生活工具租賃</p>', description: '園藝工具、車體美容用品、燈光設備、水電裝修設備...等', img: require("@/assets/images/main-type-6.svg") },
      { id: 3, type: 3, code: '旅生活樂齡', title: '<p>旅生活樂齡0~100歲用品租賃</p>', description: '樂高、桌遊、兒童玩具、嬰兒汽車座椅、嬰兒床、電動搖籃、長照輔具...等', img: require("@/assets/images/main-type-5.svg") },
      { id: 4, type: 4, code: '旅生活旅宿', title: '<p>旅生活旅宿租賃</p>', description: '設計傢俱、綠色家電、藝術品（掛畫、攝影作品）...等', img: require("@/assets/images/main-type-4.svg") },
      { id: 5, type: 5, code: '旅生活寵物', title: '<p>旅生活寵物用品租賃</p>', description: '寵物推車、寵物運輸籠、寵物烘箱...等', img: require("@/assets/images/main-type-3.svg") },
      { id: 6, type: 6, code: '旅生活戶外', title: '<p>旅生活戶外<br>工具租賃</p>', description: '露營設備、潛水設備、釣魚設備...等', img: require("@/assets/images/main-type-2.svg") },
    ],
    // 車種清單
    selectCarTypes: [],
    carTypes: [
      { id: 1, code: "sedan", type: 1, content: "燃油車", title: "燃油車", img: require('@/assets/images/sub-type-1.png') },
      { id: 7, code: "hybrid_car", type: 1, content: "油電車", title: "油電車", img: require("@/assets/images/sub-type-油電車.png") },
      { id: 6, code: "electric_car", type: 1, content: "電動車", title: "電動車", img: require("@/assets/images/sub-type-電動車.png") },
      { id: 2, code: "motorcycle", type: 1, content: "機車(燃油車)", title: "機車(燃油車)", img: require('@/assets/images/sub-type-5.svg') },
      { id: 5, code: "electric_motorcycle", type: 1, content: "電動機車", title: "電動機車", img: require('@/assets/images/sub-type-電動機車.png') },
      { id: 3, code: "electric", type: 1, content: "電動輔助腳踏車", title: "電動輔助腳踏車", img: require('@/assets/images/sub-type-2.svg') },
      { id: 4, code: "bicycle", type: 1, content: "腳踏車", title: "腳踏車", img: require('@/assets/images/sub-type-3.svg') },

      { id: 22, code: "home_garden_tools", type: 2, content: "居家 / 園藝工具", title: "居家 / 園藝工具", img: "" },
      { id: 23, code: "car_care_products", type: 2, content: "車體美容用品", title: "車體美容用品", img: "" },
      { id: 24, code: "exhibition_lighting", type: 2, content: "展覽 / 燈光設備", title: "展覽 / 燈光設備", img: "" },
      { id: 25, code: "hardware_engineering", type: 2, content: "五金 / 工程設備", title: "五金 / 工程設備", img: "" },
      { id: 26, code: "commercial_equipment", type: 2, content: "商用設備", title: "商用設備", img: "" },
      { id: 27, code: "photography_equipment", type: 2, content: "攝影設備", title: "攝影設備", img: "" },
      { id: 28, code: "electronic_devices", type: 2, content: "電子設備", title: "電子設備", img: "" },

      { id: 8, code: "children_toys", type: 3, content: "兒童玩具", title: "兒童玩具", img: require('@/assets/images/sub-type-8.png') },
      { id: 9, code: "baby_car_seat", type: 3, content: "嬰兒汽車座（餐）椅", title: "嬰兒汽車座（餐）椅", img: require('@/assets/images/sub-type-9.png') },
      { id: 10, code: "baby_crib", type: 3, content: "嬰兒床", title: "嬰兒床", img: require('@/assets/images/sub-type-10.png') },
      { id: 11, code: "electric_cradle", type: 3, content: "電動搖籃", title: "電動搖籃", img: require('@/assets/images/sub-type-11.png') },
      { id: 12, code: "auxiliary", type: 3, content: "長照輔具", title: "長照輔具", img: require('@/assets/images/sub-type-12.png') },
      { id: 13, code: "medical_supplies", type: 3, content: "醫療用品", title: "醫療用品", img: require('@/assets/images/sub-type-13.png') },
      { id: 64, code: "3c", type: 3, content: "3C產品", title: "3C產品", img: require('@/assets/images/sub-type-17.png') },

      { id: 14, code: "design_furniture", type: 4, content: "設計傢俱", title: "設計傢俱", img: "" },
      { id: 15, code: "green_appliances", type: 4, content: "綠色家電", title: "綠色家電", img: "" },
      { id: 16, code: "artwork", type: 4, content: "藝術品", title: "藝術品", img: "" },
      { id: 29, code: "decorative_props", type: 4, content: "佈置用道具", title: "佈置用道具", img: "" },
      { id: 30, code: "theatrical_props", type: 4, content: "戲劇用道具", title: "戲劇用道具", img: "" },

      { id: 17, code: "pet_stroller", type: 5, content: "寵物推車", title: "寵物推車", img: "" },
      { id: 18, code: "pet_transport_cage", type: 5, content: "寵物運輸籠", title: "寵物運輸籠", img: "" },
      { id: 19, code: "smart_cat_litter", type: 5, content: "智慧貓砂盆", title: "智慧貓砂盆", img: "" },
      { id: 20, code: "pet_oven", type: 5, content: "寵物烘箱", title: "寵物烘箱", img: "" },
      { id: 21, code: "pet_bicycle_basket", type: 5, content: "寵物自行車掛籃", title: "寵物自行車掛籃", img: "" },
      { id: 31, code: "pet_oxygen_machine", type: 5, content: "寵物氧氣機", title: "寵物氧氣機", img: "" },

      { id: 61, code: "outdoor_sports", type: 6, content: "戶外運動設備", title: "戶外運動設備", img: require('@/assets/images/sub-type-14.png') },
      { id: 62, code: "water_sports", type: 6, content: "水上運動設備", title: "水上運動設備", img: require('@/assets/images/sub-type-15.png') },
      { id: 63, code: "sup", type: 6, content: "SUP", title: "SUP", img: require('@/assets/images/sub-type-16.png') },
    ],
    // 處理預約表單
    register: {
      itemType: 0,
      stationId: 0,
      peoples: 1,
      carType: 0,
      carTypes: [],
      selectCity: "全部",
      timeType: "",
      startTime: "",
      endTime: "",
      hours: 0,
      days: 0,
      note: ""
    },
    // 所有預約紀錄
    registerOrders: [],
    // 目前處理訂單
    currentOrder: {},
    // 目前處理預約
    currentRegister: {}
  },
  components: {

  },
  mounted () {

  },
  async created () {
    // 載入相關工具
    this.apis = new APIs(this)
    this.common = new Common(this)
    this.liff = new LiffSdk(this)

    // 處理執行階段代碼
    this.run_code = this.common.generAtorMoreEng(10)

    // 處理指定的 Liff ID
    if (this.$route.params.liffId) {
      this.liffId = this.$route.params.liffId
    }
    if (this.$route.params.actionType) {
      this.actionType = this.$route.params.actionType
    }

    // 處理開發模式
    if (process.env.VUE_APP_NODE === 'dev') {
      this.member = {
        userId: 1,
        user_lineId: "U25cca09d9ed60ebc15a47a95ba6a43b5",
        user_name: "Tester",
        user_picture: "https://profile.line-scdn.net/0hwe1EOPPLKEocPANvUBVWNWxsKyA_TXFYMlljLSpvJHolX24ZYF1ieSg5JnJ1WGxLNA1lKXw6dCkQL18sAmrUfhsMdn0lC2cZOVhjqQ",
        user_phone: "+886999999999",
        name: "測試人員"
      }

      // 處理預約紀錄清單
      this.getReserveOrders()
    }

    // 初始化 Liff APP
    setTimeout(() => {
      this.liff.loadSDK(this.liffId, true)
    }, 500)
  },
  methods: {
    async loadStations () {
      let vm = this
      await this.$http.get('https://didifun-api.jbravo.dev/api/wb/v1/stations').then(async function (_response) {
        let stationData = await _response.body.data
        let stations = []
        let demoUserStatus = (['U25cca09d9ed60ebc15a47a95ba6a43b5', 'U73292fb1f87039990d4b833ebe96f98b', 'U0abeefadfd1c399b0dfa88e8533fff23'].indexOf(vm.member.user_lineId) > -1)
        stationData.forEach(function (_station) {
          if (_station.demoStatus && !demoUserStatus) {
            return
          }

          _station.banner = require("@/assets/images/store-banner-0" + _station.typeId + ".png")
          _station.regBanner = require("@/assets/images/store-reg-banner-0" + _station.typeId + ".png")
          stations.push(_station)
        })

        vm.stations = stations
        console.log('--> 整理的店家資料結果: ', stations)
      })
    },
    goPage (_path, _params = {}) {
      this.$router.push({ path: _path, params: _params })
    },
    // 請求獲得用戶資料
    getUserData () {
      let vm = this
      this.apis.getUserData(this.member.user_lineId, function (_response) {
        vm.member = _response.body.data
      })
    },
    // 請求處理用戶資料
    processUserData () {
      let vm = this
      this.apis.setUserData(this.user, function (_response) {
        vm.member = _response.body.data
        vm.apis.sendLogToSlack('Member Data: ' + JSON.stringify(vm.member))

        // 處理預約紀錄清單
        vm.getReserveOrders()
      })
    },
    // 請求獲得用戶預約紀錄
    getReserveOrders () {
      let vm = this
      this.$root.apis.getReserveOrders(this.member.user_lineId, function (_response) {
        let orders = _response.body.data
        vm.registerOrders = orders
      })
    },
    hasShop (_cityName) {
      let vm = this

      if (_cityName === '全部') {
        return true
      }

      console.log('--> 檢查縣市:', _cityName)

      let searchStatus = false
      this.stations.forEach(function (station) {
        if (station.city === _cityName) {
          if (vm.hasProduct(station)) {
            searchStatus = true
          }
        }
      })

      console.log('--> 品類:', this.register.itemType, '縣市[' + _cityName + ']篩選結果: ', searchStatus);

      return searchStatus
    },
    hasProduct (_stationData) {
      let vm = this
      let searchStatus = false
      this.register.carTypes.forEach(function (_selectCar) {
        let carData
        vm.carTypes.forEach(function (_row) {
          if (_row.id === _selectCar.id) {
            carData = _row
          }
        })
        if (carData.code && _stationData.cars[carData.code] > 0) {
          searchStatus = true
        }
      })

      console.log('--> 店家:', _stationData.name, '結果:', searchStatus)

      return searchStatus
    }
  }
}).$mount('#app')
